import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type UserPreferences = components["schemas"]["UserPreferences"];
export type UpdatePreferencesRequest = components["schemas"]["UpdatePreferencesRequest"];

/** GET /v1/me/preferences — the user's personalization preferences. */
export async function getPreferences(): Promise<UserPreferences> {
  return unwrap(await api.GET("/v1/me/preferences"));
}

/**
 * PUT /v1/me/preferences — partial update; the request schema is all-optional,
 * so callers send only the fields that changed.
 */
export async function updatePreferences(
  body: UpdatePreferencesRequest,
): Promise<UserPreferences> {
  return unwrap(await api.PUT("/v1/me/preferences", { body }));
}
